<div class="modal-header">
  <h4 class="modal-title">Rule Analytics</h4>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body">
  <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
  <div class="desc-body">
    <div *ngIf="isKeyAlgo" [innerHTML]="highlightedText"></div>
    <div *ngIf="!isKeyAlgo">
      <ng-container *ngFor="let item of descriptionData">
        <div [innerHTML]="item.firstText"></div>
        <textarea class="text-area-css" cdkTextareaAutosize disabled>
          {{item.secondText}}
        </textarea>
      </ng-container>
    </div>
  </div>
  <app-progress-bar [isLoading]="isRuleSaveLoading"></app-progress-bar>
  <div class="row mt-3 row-m-0">
    <div class="col-lg-2">
      <form class="form-inline d-flex md-form form-sm">
        <label class="control-label control-label-mb">Search Keys</label>
        <input class="form-control form-control-sm width-90pr mt-2" (keydown)="onEnterSearchKeys($event, 'Policy')"
          [(ngModel)]="policySearchText" type="text" placeholder="Search" name="search" aria-label="Search" />
        <i class="fa fa-search search-icon cursor-pointer" (click)="searchKeys('Policy')" aria-hidden="true"></i>
      </form>
    </div>
    <div class="col-lg-3">
      <label class="control-label">Policy Name</label>
      <select class="form-control form-control-sm" [(ngModel)]="ruleAnalyticData.policy"
        (change)="getSectionList($event.target.value)">
        <option *ngFor="let policy of policies" value="{{policy}}">{{policy}}</option>
      </select>
    </div>
    <div class="col-lg-3">
      <label class="control-label">Policy Section</label>
      <select class="form-control form-control-sm" [(ngModel)]="ruleAnalyticData.policySection"
        (change)="getSubSectionList(ruleAnalyticData.policy, $event.target.value)">
        <option *ngFor="let section of section1" value="{{section}}">{{section}}</option>
      </select>
    </div>
    <div class="col-lg-3">
      <label class="control-label">Policy Sub-Section</label>
      <select class="form-control form-control-sm" [(ngModel)]="ruleAnalyticData.policySubSection">
        <option *ngFor="let section of section2" value="{{section}}">{{section}}</option>
      </select>
    </div>
    <div class="col-lg-1 pt-4">
      <button class="btn btn-sm" (click)="saveRuleAnalytic()">Save</button>
    </div>
    <div class="col-lg-12 mt-3 col-p mb-1">
      <div class="text-blue" *ngIf="(ruleAnalyticList && (ruleAnalyticList.length>0))">
        {{endIndex}} out of {{totalCount}}
      </div>
      <app-progress-bar [isLoading]="isRuleCopyLoading"></app-progress-bar>
      <div class="table-responsive box-shadow setHeight table-cont" #tableContent>
        <table class="table table-fixed table-hover">
          <thead>
            <tr>
              <th class="pointer col-lg-1 mx-width-9pr">Rulebook Id</th>
              <th class="pointer col-lg-2 mx-width-16pr">Relevant Keys</th>
              <th class="pointer col-lg-2 mx-width-16pr">Requirements</th>
              <th class="pointer col-lg-2 mx-width-14pr">Policy Name</th>
              <th class="pointer col-lg-2 mx-width-14pr">Policy Section</th>
              <th class="pointer col-lg-2 mx-width-14pr">Policy Sub-Section</th>
              <th class="pointer col-lg-1 mx-width-10pr">Gaps</th>
              <th class="pointer col-lg-1 mx-width-7pr">Action</th>
            </tr>
          </thead>
          <tbody class="policy-list-div" *ngIf="ruleAnalyticList">
            <tr *ngFor="let item of ruleAnalyticList"
              [ngClass]="{ 'selected-row': selectedRuleAnalytic && selectedRuleAnalytic.id === item.id }"
              (click)="changeRuleAnalytic(item)">
              <td class="col-lg-1 mx-width-9pr">{{item.rulebookId}}</td>
              <td class="col-lg-2 tbl-td-scroll mx-width-16pr">{{item.oneWord }} {{item.twoWord}}
                {{item.mapCustomKeys}}
              </td>
              <td class="col-lg-2 tbl-td-scroll mx-width-16pr tbl-td-scroll" [innerHTML]="item.modalRequirements">
              </td>
              <td class="col-lg-2 tbl-td-scroll mx-width-14pr">{{item.policyName}}</td>
              <td class="col-lg-2 tbl-td-scroll mx-width-14pr">{{item.policySection}}</td>
              <td class="col-lg-2 tbl-td-scroll mx-width-14pr">{{item.policySubSection}}</td>
              <td class="col-lg-2 tbl-td-scroll mx-width-10pr">{{item.gap}}</td>
              <td class="col-lg-1 mx-width-7pr">
                <span class="fg-g-red" (click)="removeRuleAnalytic(item.id)">Delete</span>
                | <span class="text-blue" (click)="copyRuleAnalytic(item)">Copy</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
  <div class="row mt-4 row-m-0">
    <div class="col-lg-2">
      <form class="form-inline d-flex md-form form-sm">
        <label class="control-label control-label-mb">Search Keys</label>
        <input class="form-control form-control-sm width-90pr" (keydown)="onEnterSearchKeys($event, 'Keyword')"
          [(ngModel)]="keySearchText" type="text" name="search" aria-label="Search" />
        <i class="fa fa-search search-icon cursor-pointer" (click)="searchKeys('Keyword')" aria-hidden="true"></i>
      </form>
    </div>
    <div class="col-lg-2">
      <label class="control-label control-label-mb">No. of Keys</label>
      <input type="number" min="1" [(ngModel)]="keywordSearch.keywordCount" class="form-control form-control-sm" />
    </div>
    <div class="col-lg-1 pt-4 mx-width-4pr">
      <button class="btn btn-sm" (click)="getKeywordsData('GO')">Run</button>
    </div>
    <div class="col-lg-2">
      <label class="control-labelcontrol-label-mb">Highlight Using</label>
      <select class="form-control form-control-sm" (change)="getKeywordList()" [(ngModel)]="keywordSearch.keywordType">
        <option value="yake">Relevant Keys 1</option>
        <option value="rake">Relevant Keys 2</option>
        <option value="obligations">Obligations</option>
      </select>
    </div>
    <div class="col-lg-5 pt-4">
      <button class="btn btn-sm" (click)="getTextHighlightedData()">Go</button>
    </div>
  </div>
  <div class="row mt-3 pb-4 row-m-0">
    <div class="col-lg-6">
      <div class="row">
        <div class="col-lg-6 col-p">
          <div class="card">
            <div class="card-header text-header">
              Relevant Keys 1
            </div>
            <div class="card-body left-max-div">
              <div class="word-div" *ngFor="let item of keywordData.oneWordList">
                <div>
                  <i class="fa fa-square-o icon-font" (click)="selectOneWordItem('Checked', item.keyword)"
                    *ngIf="!getSelectedItems(item.keyword, 'OneWord')"></i>
                  <i class="fa fa-check-square icon-font" (click)="selectOneWordItem('UnChecked', item.keyword)"
                    *ngIf="getSelectedItems(item.keyword, 'OneWord')"></i>
                  <span class="word-css">{{item.keyword}}</span>
                </div>
                <div class="row">
                  <div class="col-lg-4"><small>{{item.frequency}} times</small></div>
                  <div class="col-lg-8"><small class="pull-right">Relevance <span class="text-purple">{{item.rank |
                        number:'0.1-3'}}</span></small></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-p">
          <div class="card">
            <div class="card-header text-header">
              Relevant Keys 2
            </div>
            <div class="card-body left-max-div">
              <div class="word-div" *ngFor="let item of keywordData.twoWordList">
                <div>
                  <i class="fa fa-square-o icon-font" (click)="selectTwoWordItem('Checked', item.keyword)"
                    *ngIf="!getSelectedItems(item.keyword, 'TwoWord')"></i>
                  <i class="fa fa-check-square icon-font" (click)="selectTwoWordItem('UnChecked', item.keyword)"
                    *ngIf="getSelectedItems(item.keyword, 'TwoWord')"></i>
                  <span class="word-css">{{item.keyword}}</span>
                </div>
                <div class="row">
                  <div class="col-lg-4"><small>{{item.frequency}} times</small></div>
                  <div class="col-lg-8"><small class="pull-right">Relevance <span class="text-purple">{{item.rank |
                        number:'0.1-3'}}</span></small></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-p">
      <div class="card">
        <mat-accordion>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header aria-expanded="true">
              <mat-panel-title>
                <span class="text-header">Obligations</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="table-responsive box-shadow">
              <table class="table table-fixed table-hover">
                <thead>
                  <tr>
                    <th class="pointer col-lg-2 mx-width-15pr">Rulebook Id</th>
                    <th class="pointer col-lg-10">Obligation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of modalRequirement">
                    <td class="col-lg-2 mx-width-15pr">
                      <i class="fa fa-square-o icon-font" (click)="selectObligation('Checked', item)"
                        *ngIf="!getSelectedObligations(item.id)" aria-hidden="true"></i>
                      <i class="fa fa-check-square icon-font" (click)="selectObligation('UnChecked', item)"
                        *ngIf="getSelectedObligations(item.id)" aria-hidden="true"></i>
                      <span>{{ item.id }}</span>
                    </td>
                    <td class="col-lg-10 tabel-td-scroll">
                      <div [innerHTML]="sanitizeHtml(item.regulatorRuleFullRequirement)"
                        *ngIf="!getSelectedObligations(item.id)">
                      </div>
                      <app-ck-editor [(childVariable)]="item.regulatorRuleFullRequirement" class="angular-editor"
                        *ngIf="getSelectedObligations(item.id)"></app-ck-editor>
                      <!-- <ckeditor [editor]="Editor" class="angular-editor" *ngIf="getSelectedObligations(item.id)"
                        [(ngModel)]="item.regulatorRuleFullRequirement">
                      </ckeditor> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
    <div class="col-lg-12 col-p">
      <div class="card mt-1">
        <mat-accordion>
          <mat-expansion-panel [expanded]="isExpanded">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="text-header">Map Custom Keys</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-chip-grid #mapKeyList>
              <mat-chip-row *ngFor="let type of ruleAnalyticData.mapCustomKeys" [selectable]="selectable"
                [removable]="removable" (removed)="removeKeys(type)">
                {{type}}
                <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
              </mat-chip-row>
              <input class="form-control form-control-sm border-bottom" id="mapKey" autocomplete="off"
                [matChipInputFor]="mapKeyList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addKeys($event)">
            </mat-chip-grid>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="mt-1 display-flow-root text-blue" (click)="saveGapComments()">
        <span class="pull-right">Save</span>
      </div>
      <div class="card mt-1">
        <mat-accordion>
          <mat-expansion-panel [expanded]="isExpanded">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="text-header">Gaps</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-chip-grid #gapList>
              <mat-chip-row *ngFor="let type of ruleAnalyticData.gaps" [selectable]="selectable" [removable]="removable"
                (removed)="removeGaps(type)">
                {{type}}
                <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
              </mat-chip-row>
              <input class="form-control form-control-sm border-bottom" id="gapKey" autocomplete="off"
                [matChipInputFor]="gapList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addGaps($event)">
            </mat-chip-grid>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="card mt-1">
        <mat-accordion>
          <mat-expansion-panel [expanded]="isExpanded">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="text-header">Comments</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-chip-grid #commentList>
              <mat-chip-row *ngFor="let type of ruleAnalyticData.comments" [selectable]="selectable"
                [removable]="removable" (removed)="removeComments(type)">
                {{type}}
                <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
              </mat-chip-row>
              <input class="form-control form-control-sm border-bottom" id="commentKey" autocomplete="off"
                [matChipInputFor]="commentList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addComments($event)">
            </mat-chip-grid>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>